jQuery(document).ready(function($) {

  if ( $('.filter-sidebar').length > 0 ) {

    var isPeople    = $('body').hasClass('page-template-template-people');
    var isPaginated = false;

    $('.search-placeholder').on('click',function() {
      $('.filter-list-item-search').focus();
    });

    $('.filter-list-item-search').on('keypress', function(e) {

      if (e.which === 13) {

        if ($(this).val()) {

          $(this).addClass('has-input');

          if (isPeople) {
            $('.filter-list-item-type-a').removeClass('is-filtered');
            $('.filter-title').removeClass('is-showing');
          }

          ajaxQuery();

        } else {
          $(this).removeClass('has-input');
          ajaxQuery();
        }

      }

    });

    $('.filter-list-item-subparent span').on('click', function() {
      $(this).parent().toggleClass('is-showing');
    });

    $('.filter-list-item-a').on( 'click', function(e) {

      e.preventDefault();
      var type = $(this).data('type');

      if ( !$(this).hasClass('is-filtered') ) {

        if (isPeople) {

          $('.filter-list-item-a').removeClass('is-filtered');
          $('.filter-title').removeClass('is-showing');
          $(this).closest('.filter-list').parent().find('h4').addClass('is-showing');

          if ( $(this).hasClass('filter-list-item-a-subchild') ) {
            $(this).closest('.filter-list-item-subparent').addClass('is-showing');
          }

        }

        $(this).parent().parent().find('.filter-list-item-a').removeClass('is-filtered');
        $('.filter-list-item-'+type+'-a.is-filtered').removeClass('is-filtered');
        $(this).addClass('is-filtered');
        ajaxQuery();

      }

    });

    $('.grid-pagination-button').on( 'click', function(e) {

      e.preventDefault();

      isPaginated = true;

      if ($(this).hasClass('grid-pagination-button-previous')) {
        var paged = $(this).data('previous');
        ajaxQuery(paged);
      } else if($(this).hasClass('grid-pagination-button-next')) {
        var paged = $(this).data('next');
        ajaxQuery(paged);
      }

    });

    $('.grid-pagination').on( 'click', '.grid-pagination-page', function(e) {

      e.preventDefault();
      var paged = $(this).data('page');
      isPaginated = true;
      $('.grid-pagination-page').removeClass('is-active');
      $(this).addClass('is-active');
      ajaxQuery(paged);

    });

    $('.filter-title').on( 'click', function(e) {
      $(this).toggleClass('is-showing');
    });

    var ajaxQuery = function( paged = 1 ) {

      var type     = typeof $('.filter-list-item-type-a.is-filtered').data('filter') === 'undefined' ? '' : $('.filter-list-item-type-a.is-filtered').data('filter');
      var sector   = typeof $('.filter-list-item-sector-a.is-filtered').data('filter') === 'undefined' ? '' : $('.filter-list-item-sector-a.is-filtered').data('filter');
      var region   = typeof $('.filter-list-item-region-a.is-filtered').data('filter') === 'undefined' ? '' : $('.filter-list-item-region-a.is-filtered').data('filter');
      var year     = typeof $('.filter-list-item-year-a.is-filtered').data('filter') === 'undefined' ? '' : $('.filter-list-item-year-a.is-filtered').data('filter');
      var location = typeof $('.filter-list-item-location-a.is-filtered').data('filter') === 'undefined' ? '' : $('.filter-list-item-location-a.is-filtered').data('filter');
      var previous = $('.grid-pagination-button-previous').data('previous');
      var next     = $('.grid-pagination-button-next').data('next');
      var content  = $('.grid-items').data('content');

      var filterValues = {
        'filter_search'   : $('.filter-list-item-search').val(),
        'filter_type'     : type,
        'filter_sector'   : sector,
        'filter_region'   : region,
        'filter_year'     : year,
        'filter_location' : location,
        'filter_cats'     : [type,sector,location,region,year],
        'content'         : content,
        'previous'        : previous,
        'next'            : next,
        'paged'           : paged
      };

      // console.log(filterValues);

      $.ajax({
  			type       : "POST",
  			url        : localized_object.ajax_url,
  			data       : {
          action : 'get_ajax_content',
          data   : filterValues
        },
  			dataType   : "json",
  			timeout    : 90000000,
  			beforeSend : function() { $('.grid-content').addClass('is-loading')}
	    })
	    .done( function( response ) {

        //console.log(response.pagination);

        $('.grid-items').html(response.posts);
        $('.grid-content').removeClass('is-loading');

        var previous = $('.grid-pagination-button-previous').data('previous', response.previous );
        var next     = $('.grid-pagination-button-next').data('next', response.next );
        //var current  = response.next - 1;

        if (response.previous < 0 ) {
          previous.addClass('is-hidden');
        } else {
          previous.removeClass('is-hidden');
        }

        if (response.next < 0 ) {
          next.addClass('is-hidden');
        } else {
          next.removeClass('is-hidden');
        }

        if ( response.pagination ) {
          $('.grid-pagination--pages').html(response.pagination);
        }

        if ( isPaginated ) {

          //console.log(isPaginated);

          var gridOffset = $('.grid-items').offset();
          var bannerHeight = $('.banner').height();

          $('html, body').animate({
            scrollTop: gridOffset.top - bannerHeight
          }, 750);

        }

	    })
	    .fail( function( request, status, err ) {
  			console.log( 'REQUEST => ' + request );
  			console.log( 'STATUS => ' + status );
  			console.log( 'ERR => ' );
  			console.log( err );
	    });

    }

  }

});
